var exports = {
  "container": "x43cbe9c2--c42c8d--container",
  "wrapper": "x43cbe9c2--c42c8d--wrapper",
  "first-blue": "x43cbe9c2--c42c8d--first-blue",
  "first-white": "x43cbe9c2--c42c8d--first-white",
  "content": "x43cbe9c2--c42c8d--content",
  "main-title": "x43cbe9c2--c42c8d--main-title",
  "main-title-outside": "x43cbe9c2--c42c8d--main-title-outside",
  "nav-container": "x43cbe9c2--c42c8d--nav-container",
  "step": "x43cbe9c2--c42c8d--step",
  "sale": "x43cbe9c2--c42c8d--sale",
  "rent": "x43cbe9c2--c42c8d--rent",
  "host": "x43cbe9c2--c42c8d--host",
  "step-text": "x43cbe9c2--c42c8d--step-text",
  "title": "x43cbe9c2--c42c8d--title",
  "arrows": "x43cbe9c2--c42c8d--arrows",
  "arrow": "x43cbe9c2--c42c8d--arrow",
  "arrow-next": "x43cbe9c2--c42c8d--arrow-next",
  "arrow-prev": "x43cbe9c2--c42c8d--arrow-prev",
  "banner": "x43cbe9c2--c42c8d--banner",
  "tablet": "x43cbe9c2--c42c8d--tablet",
  "phone": "x43cbe9c2--c42c8d--phone",
};

module.exports = exports;
